var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin": "10px"
    }
  }, [_c('div'), _vm._v(" "), _c('div', {
    staticClass: "thumb-container",
    staticStyle: {
      "width": "100%",
      "text-align": "right",
      "overflow-y": "auto"
    },
    style: ({
      'max-height': _vm.mh ? _vm.mh + 'px' : 'unset'
    }),
    attrs: {
      "id": "scroll-thumb"
    }
  }, [_vm._l((_vm.brothers), function(preview) {
    return (_vm.ready && _vm.brothers && _vm.brothers.length > 0) ? _c('div', {
      staticClass: "thumbnail",
      class: {
        'active': preview.sid == _vm.activeOne.sid
      }
    }, [_c('a', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.navigateToBrother(preview)
        }
      }
    }, [_c('div', {
      staticClass: "caption"
    }, [_c('p', [_vm._v(_vm._s(preview.des))])]), _vm._v(" "), _c('div', {
      staticClass: "embed-responsive embed-responsive-4by3 bg-cover",
      staticStyle: {
        "width": "100%"
      },
      style: ({
        'background-image': 'url(' + _vm.$root.getGraphic(preview.gra[0].sfn, 'thumb', true) + ')'
      })
    })])]) : _vm._e()
  }), _vm._v(" "), (_vm.ready && _vm.brothers.length == 0) ? _c('div', {
    staticStyle: {
      "text-align": "center",
      "padding-top": "10px"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$Jed.firstUpperTranslate('no preview available', null)))])]) : _vm._e()], 2)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5cc4fdd4","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/menu-sup-components/Anteprime.vue
// module id = 1435
// module chunks = 1